<template>
  <div class="font-size-color">
    <div class="title">描边颜色</div>
    <div
      class="color-item"
      :style="{backgroundColor: color}"
      @click.stop="clickColor($event)"
    ></div>
    <div class="size-item">
      <div
        class="minus"
        @mousedown="minus"
        @mouseup="mouseupBtn"
      ></div>
      <input
        class="input"
        type="text"
        v-model="sizeWithUnit"
        @click="focusInput($event)"
        @keydown="keydownInput($event)"
        @blur="blurInput"
        ref="input"
      />
      <div
        class="plus"
        @mousedown="plus"
        @mouseup="mouseupBtn"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
function mid (val, min, max) {
  return Math.min(Math.max(min, val), max);
}
const MAX_SIZE = 10;
export default {
  data () {
    return {
      size: 0,
      color: '#c7c7c7'
    }
  },
  computed: {
    ...mapGetters({
      subtitle: 'subtitle/selectSubtitle'
    }),
    sizeWithUnit: {
      get () {
        if (!this.size && this.size !== 0) {
          return 'px'
        }
        let str = parseInt(this.size || 0) + 'px';
        return str
      },
      set (v) {
        this.size = v == 'px' ? 0 : v;
        let re = /[^0-9\.]/g;
        v = v.replace(re, '');
        let str = '';
        let passDot = false;
        for (let i = 0; i < v.length; i++) {
          if (v[i] === '.') {
            if (!passDot) {
              str += v[i];
              passDot = true;
            }
          } else {
            str += v[i];
          }
        }
        v = +str;

        v = parseInt(v);
        v = mid(v, 0, MAX_SIZE);
        this.size = v;
        this.$store.commit('subtitle/updateSubtitleUndo', {
          subtitle: {
            font: {
              myTextStroke: v
            }
          }
        });
      }
    }
  },
  watch: {
    size () {
      this.$nextTick(() => {
        this.$refs.input && this.focusInput({ target: this.$refs.input });
      })
    }
  },
  created () {
    this.$watch(function () {
      if (this.subtitle) {
        return this.subtitle.font.myTextStroke
      }
    }, function (val, oldVal) {
      this.size = val == null ? 1 : val
    });

    this.$watch(function () {
      if (this.subtitle) {
        return this.subtitle.font.myTextStrokeColor
      }
    }, function (val, oldVal) {
      this.color = val
    });

    this.$bus.on(`cloud.colorPickerInput`, (obj, data) => {
      if (data.from === 'subtitleTextOutlineColor') {
        let color = obj.hex;
        this.$store.commit('subtitle/updateSubtitleUndo', {
          subtitle: {
            font: {
              myTextStrokeColor: color
            }
          }
        });
      }
    });
  },
  mounted () {
    let container = document.querySelector('#subtitle');
    container.addEventListener('click', (ev) => {
      if (ev.target.closest('.setting-popup')) {
        return;
      }
      // this.$bus.emit('subtitlePopupClose', {
      //   name: 'color-cloud',
      //   type: 3
      // });
      this.$bus.emit("wordCloud.hidePopups");
    });
  },
  methods: {
    focusInput (ev) {
      let value = ev.target.value;
      let len = value.length;
      if (/px$/.test(value)) {
        ev.target.setSelectionRange(len - 2, len - 2);
      }
    },
    keydownInput (ev) {
      if (ev.code === 'ArrowUp') {
        ev.preventDefault();
        this.plus();
      }
      if (ev.code === 'ArrowDown') {
        ev.preventDefault();
        this.minus();
      }
      if (ev.code === 'Backspace') {
        this.focusInput(ev);
      }
    },
    blurInput () {
      this.sizeWithUnit = this.size + 'px'
    },
    plus () {
      let val = this.size;
      val += 1;
      this.$store.commit('subtitle/updateSubtitleUndo', {
        subtitle: {
          font: {
            myTextStroke: mid(val, 0, MAX_SIZE)
          }
        }
      });
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.plus();
      }, 150);
    },
    minus () {
      let val = this.size;
      val -= 1;
      this.$store.commit('subtitle/updateSubtitleUndo', {
        subtitle: {
          font: {
            myTextStroke: mid(val, 0, MAX_SIZE)
          }
        }
      });
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.minus();
      }, 150);
    },
    mouseupBtn () {
      clearTimeout(this.timer);
    },

    clickColor (ev) {
      let el = ev.currentTarget;
      let rect = el.getBoundingClientRect();
      this.$bus.emit('subtitlePopup', {
        name: 'color-cloud',
        // 使用了mixins popup.vue 下两字段就非必传
        posx: rect.right - 212,
        posy: rect.bottom + 10,
        type: 1,
        hasEyedropper: false,
        color: this.color,
        from: 'subtitleTextOutlineColor',
        isHideFooter: true,
        // source: this,
        // whichPart,
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.font-size-color {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.size-item {
  display: flex;
  align-items: center;
}
.minus,
.plus {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 24px;
  border: 1px solid #d9ddea;
  border-radius: 4px 0px 0px 4px;
  cursor: pointer;
  &:hover {
    background: #f0f0f8;
  }
}
.minus:before,
.plus:before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  content: ' ';
  width: 10px;
  height: 2px;
  background-color: #797b9a;
}
.plus:after {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  content: ' ';
  width: 2px;
  height: 10px;
  background-color: #797b9a;
}
.plus {
  border-radius: 0px 4px 4px 0px;
}
.input {
  width: 58px;
  height: 24px;
  border-width: 0;
  border-top: 1px solid #d9ddea;
  border-bottom: 1px solid #d9ddea;
  font-size: 12px;
  color: #737596;
  line-height: 48px;
  text-align: center;
}

.color-item {
  width: 36px;
  height: 24px;
  background: rgba(87, 120, 251, 1);
  border: 1px solid rgba(217, 221, 234, 1);
  border-radius: 4px;
  cursor: pointer;
  margin-right: 8px;
}

.title {
  font-size: 12px;
  color: #737596;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitlePanel/textOutline.vue